import * as localforage from "localforage";
import { phpRequest } from "./phpRequest";

export const valueAddedServicesAPI = async () => {
  const data = await phpRequest.get("/value-added-services");

  await localforage.setItem("valueAddedServices", data.value_added_services);
  return data.value_added_services;
};
